export interface UserAuthData {
  idUser: number;
  idEmp?: number;
  idPerfil?: number;
  perfil?: string;
  last_session?: string;
  nombres?: string;
  apellidos?: string;
  tipo_doc?: string;
  documento?: string;
  id_cargo?: number;
  cargo?: string;
  correo_corporativo?: string;
  correo_alterno?: string;
  telefono?: string;
  direccion?: string;
  imagen?: string;
  status?: string;
  pass?: string;
  passtemp?: string
  nomstatus?: string;

}

//Nombre completo del empleado
export function getFullName(user: UserAuthData): string {
  return `${user.nombres} ${user.apellidos}`;
}
